import { ReactNode } from 'react';
import { TableItemHighlightedText } from './highlight/TableItemHighlightedText';
import { PossibleSectionInDependencies } from './types';

interface LabelWrapperComponentProps {
  label: string | ReactNode;
  rowIndex?: number;
}

interface CreateStableLabelWrapperProps {
  field: string;
  section: PossibleSectionInDependencies;
  tableType?: string;
}

/**
 * Creates a stable wrapper component that accepts rowIndex as a prop
 * This avoids creating new component functions on every render
 */
export const createStableLabelWrapper = ({
  field,
  section,
  tableType,
}: CreateStableLabelWrapperProps) => {
  const StableLabelWrapper = ({ label, rowIndex }: LabelWrapperComponentProps) => {
    // If label is not a string, return it as-is
    if (typeof label !== 'string') {
      return <>{label}</>;
    }

    return (
      <TableItemHighlightedText
        text={label}
        field={field}
        section={section}
        tableType={tableType}
        rowIndex={rowIndex}
      />
    );
  };

  return StableLabelWrapper;
};

interface CreateLabelWrapperComponentProps {
  field: string;
  section: PossibleSectionInDependencies;
  tableType?: string;
  rowIndex?: number;
}

export const createLabelWrapperComponent = ({
  field,
  section,
  tableType,
  rowIndex,
}: CreateLabelWrapperComponentProps) => {
  const LabelWrapperComponent = ({ label }: { label: string | ReactNode }) => {
    // If label is not a string, return it as-is
    if (typeof label !== 'string') {
      return <>{label}</>;
    }

    return (
      <TableItemHighlightedText
        text={label}
        field={field}
        section={section}
        tableType={tableType}
        rowIndex={rowIndex}
      />
    );
  };

  return LabelWrapperComponent;
};

export const markStyles = {
  // Allow mark tags (from highlighting) to have their own styles
  '& mark': {
    // Let inline styles from HighlightedText take precedence
    display: 'inline',
  },
};
